<template>
    <div class="searchAddition" >
        <div class="addition-item" v-for="(item,index) in washServiceAdditionList" :key="index" @click="onAddition(item)">
            {{ item.additionName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data(){
        return{
            washServiceAdditionList: [],
        }
    },
    mounted() {
        this.getWashServiceAdditionList();
    },
    methods:{
        getWashServiceAdditionList(){
            get("/wash/utils/findAllWashServiceAddition").then((res)=>{
                if(res.success){
                    this.washServiceAdditionList = res.list
                }
            })
        },

        onAddition(additionItem){
            this.$emit("onAddition", additionItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchAddition{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .addition-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>